import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekSwitch = styled(Switch)(({ theme }) => ({
    width: theme.spacing(3.2),
    height: theme.spacing(1.7),
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: theme.spacing(0.2),
        "&.Mui-checked": {
            transform: `translateX(${theme.spacing(1.5)})`,
            color: theme.palette.secondary.contrastText,
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.success.main,
            },
        },
    },
    "& .MuiSwitch-thumb": {
        color: theme.palette.secondary.contrastText,
        width: theme.spacing(1.3),
        height: theme.spacing(1.3),
        borderRadius: theme.spacing(0.65),
        transition: theme.transitions.create(["width"], {
            duration: 200,
        }),
    },
    "& .MuiSwitch-track": {
        borderRadius: theme.spacing(1.6),
        opacity: 1,
        backgroundColor: theme.palette.grey[300],
        boxSizing: "border-box",
    },
}));

export { PeekSwitch, PeekSwitch as default };
